import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Toast } from 'antd-mobile';
import PropTypes from 'prop-types';
import ClickOutSide from '../../components/clickOutside';
import tools from '../../utils/tools';
import {
  getProductDetails, getCompanyNameOptions, sendSms, openAccount,
} from '../../service/chat-service';
import checkboxActive from '../../public/images/checkbox_active.png';
import styles from './index.module.less';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const defaultProps = {
};

// 开户注册页
class Node extends React.Component {
  timer = null

  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      cuntdown: false,
      detailObj: {},
      shareUserId: tools.getQueryString('shareUserId'),
      productId: tools.getQueryString('productId'),
      time: 60,
      showOption: false,
      companyOptions: [],
      data: {
        name: '',
        phone: '',
        code: '',
        major: '',
        companyName: '',
      },
    };
  }

  componentDidMount() {
    this.detailProductData();
    this.scrollPosition();
  }

  handleComposition = (e) => {
    if (e.type === 'compositionend') {
      this.isOnComposition = false;
      this.handleCompanyChange(e);
    } else {
      this.isOnComposition = true;
    }
  }

  handleCompanyChange = (e) => {
    this.handleDataChange('companyName', e);
    if (!this.isOnComposition) {
      getCompanyNameOptions(e.target.value).then((res) => {
        this.setState({
          showOption: res && res.length > 0,
          companyOptions: res || [],
        });
      });
    }
  }

  scrollPosition = () => {
    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
    window.scrollTo(0, Math.max(scrollHeight - 1, 0));
  }

  handleSubmit = () => {
    const { detailObj, data, checked } = this.state;
    let registerProps = [];
    try {
      registerProps = JSON.parse(detailObj.registerProperties);
    } catch (e) {
      // console.log(e);
    }

    const haveNotInput = registerProps.find((item) => {
      const { isRequired, propertyKey } = item;
      const value = data[propertyKey];
      if (isRequired === '1' && !value.trim()) {
        return true;
      }
      return false;
    });

    if (haveNotInput) return Toast.show(`${haveNotInput.propertyName}为必填`, 0.8);

    if (!checked) {
      return Toast.show('请阅读并同意《用户协议》', 0.8);
    }

    if (!data.phone || data.phone.length !== 11) {
      return Toast.show('请填写正确的手机号', 0.8);
    }

    if (!data.code) {
      return Toast.show('请填写验证码', 0.8);
    }

    const productId = tools.getQueryString('productId');
    const shareUserId = tools.getQueryString('shareUserId');

    const custom = {
      phone: data.phone,
      name: data.name,
      companyName: data.companyName,
      major: data.major,
    };

    const reg = /[^\u4e00-\u9fa5a-zA-Z0-9]/;

    const companyItem = registerProps.find((item) => item.propertyKey === 'companyName');
    const nameItem = registerProps.find((item) => item.propertyKey === 'name');

    if (companyItem && companyItem.isRequired === '1') {
      if (/\s/.test(custom.companyName)) {
        return Toast.show('您填写的公司格式错误，不允许使用空格');
      }
    }

    if (nameItem && nameItem.isRequired === '1') {
      if (reg.test(custom.name)) {
        return Toast.show('您填写的姓名格式错误，不允许使用空格和特殊字符');
      }
    }

    const payload = {
      productId,
      shareUserId,
      type: 4, // 开户模式下 type=4
      accountMobile: data.phone,
      code: data.code,
      freeProperty: JSON.stringify(custom),
    };

    openAccount(payload).then((res) => {
      const { history } = this.props;
      if (res.code !== 10000) {
        return Toast.show(res.message || '请求失败', 0.8);
      }
      history.push(`/openAccountResult?shareUserId=${shareUserId}&productId=${productId}`);
      return true;
    });
    return true;
  }

  handleGetSign = () => {
    const { data, cuntdown } = this.state;
    if (cuntdown) return false;
    if (data.phone.length < 11) {
      return Toast.show('请检查手机号输入', 0.8);
    }
    // 获取验证码...
    sendSms(`?mobile=${data.phone}&type=4`)
      .then((res) => {
        if (res.code === 10000) {
          Toast.show('发送验证码成功');
          this.cuntDown();
          this.setState({
            cuntdown: true,
          });
        } else {
          Toast.show('发送验证码失败');
        }
      })
      .catch((e) => {
        Toast.show(e.message || '发送验证码失败');
      });
    return true;
  }

  handleDataChange = (field, e) => {
    const { value } = e.target;
    this.setState((state) => ({
      ...state,
      data: {
        ...state.data,
        [field]: value,
      },
    }));
  }

  handleSwitch = () => {
    this.setState((state) => ({
      checked: !state.checked,
    }));
  }

  cuntDown = () => {
    this.timer = setInterval(() => {
      this.setState((state) => {
        if (state.time <= 0) {
          clearInterval(this.timer);
          return {
            ...state,
            cuntdown: false,
            time: 60,
          };
        }
        return {
          ...state,
          time: state.time - 1,
        };
      });
    }, 1000);
  }

  async detailProductData() {
    const productId = tools.getQueryString('productId');
    const shareUserId = tools.getQueryString('shareUserId');
    Toast.loading();
    const res = await getProductDetails(`?productId=${productId}&shareUserId=${shareUserId}`);
    if (res.code === 10000) {
      this.setState({
        detailObj: res.data,
      });
    }
    Toast.hide();
  }

  renderModule = () => {
    const {
      detailObj, companyOptions, data, showOption,
    } = this.state;
    let registerProps = [];
    try {
      registerProps = JSON.parse(detailObj.registerProperties);
    } catch (e) {
      // console.log(e);
    }
    return registerProps.map((item) => {
      const { propertyKey, isRequired, propertyName } = item;
      let tips = propertyName;
      if (propertyKey === 'companyName') {
        tips = '企业的全称';
      }
      if (propertyKey === 'name') {
        tips = '身份证上的真实姓名';
      }
      const placeholder = isRequired === '1' ? `必填，请输入${tips}` : `请输入${tips}`;
      let element = null;
      switch (propertyKey) {
        case 'name':
          element = (
            <input
              key={propertyKey}
              className={styles.input}
              onBlur={this.scrollPosition}
              onChange={this.handleDataChange.bind(null, 'name')}
              maxLength={20}
              placeholder={placeholder}
              type="text"
            />
          );
          break;
        case 'companyName':
          element = (
            <div style={{ position: 'relative' }}>
              <input
                key={propertyKey}
                onBlur={this.scrollPosition}
                className={styles.input}
                onCompositionStart={this.handleComposition}
                onCompositionUpdate={this.handleComposition}
                onCompositionEnd={this.handleComposition}
                onChange={this.handleCompanyChange}
                maxLength={20}
                value={data.companyName}
                placeholder={placeholder}
                type="text"
              />

              {showOption && (
                <ClickOutSide
                  onClickOutside={() => this.setState({
                    showOption: false,
                  })}
                >
                  <div className={styles.companyList}>
                    {companyOptions.map((item1) => (
                      <div
                        onClick={() => this.setState((state) => ({
                          ...state,
                          showOption: false,
                          data: {
                            ...state.data,
                            companyName: item1,
                          },
                        }))}
                        className={styles.companyItem}
                        key={item1}
                        role="button"
                        tabIndex={0}
                      >
                        {item1}
                      </div>
                    ))}
                  </div>
                </ClickOutSide>
              )}
            </div>
          );
          break;
        case 'major':
          element = (
            <input
              key={propertyKey}
              onBlur={this.scrollPosition}
              className={styles.input}
              onChange={this.handleDataChange.bind(null, 'major')}
              maxLength={20}
              placeholder={placeholder}
              type="text"
            />
          );
          break;
        default:
          break;
      }
      return element;
    });
  }

  render() {
    const {
      checked,
      cuntdown,
      time,
      detailObj,
    } = this.state;
    const productId = tools.getQueryString('productId');
    return (
      <div className={styles.register}>
        <div className={styles.bg} />
        <img className={styles.logo} src={detailObj.logoUrl} alt="" />
        <div className={styles.card}>
          {this.renderModule()}
          <input
            onBlur={this.scrollPosition}
            className={styles.input}
            onChange={this.handleDataChange.bind(null, 'phone')}
            maxLength={11}
            placeholder="必填，请输入手机号"
            type="tel"
          />
          <div className={styles.sign}>
            <input
              onBlur={this.scrollPosition}
              onChange={this.handleDataChange.bind(null, 'code')}
              className={styles.input}
              maxLength={6}
              placeholder="请输入验证码"
              type="tel"
            />
            <span
              className={classNames(styles.tips, {
                [styles.gray]: cuntdown,
              })}
              onClick={this.handleGetSign}
              role="button"
              tabIndex={0}
            >
              {cuntdown ? `${time}S后获取验证码` : '获取验证码'}
            </span>
          </div>
          <div className={styles.copyright}>
            <span
              onClick={this.handleSwitch}
              style={{
                backgroundImage: `url(${checked ? checkboxActive : ''})`,
              }}
              className={classNames(styles.checkbox, {
                [styles.checked]: checked,
              })}
              role="checkbox"
              aria-checked
              tabIndex={0}
              label="check"
            />
            <span>
              阅读并同意
              <Link to={`/protocol?productId=${productId}`}>《用户协议》</Link>
            </span>
          </div>
          <div className={styles.submit} onClick={this.handleSubmit} role="button" tabIndex={0}>
            登录
          </div>
        </div>
      </div>
    );
  }
}

Node.propTypes = propTypes;
Node.defaultProps = defaultProps;

export default Node;
